import React from "react";
import { Box } from '@curves/ui-base';
import { Grid } from "@mui/material";
import * as echarts from "echarts/core";
import { LineChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, TitleComponent, GraphicComponent, DataZoomComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import MeasureTrendLineChart from "@Local/Dashboard/MeasureTrandLineChart";
import MeasureTrendAreaChart from "@Local/Dashboard/MeasureTrendAreaChart";
import MeasurePieBodyCompositionDistributionChart from "@Local/Dashboard/MeasurePieBodyCompositionDistributionChart";

echarts.use([LineChart, PieChart,
    GridComponent, TitleComponent, TooltipComponent, CanvasRenderer,
    GraphicComponent, DataZoomComponent]);

const Dashboard = props => {
    return (
        <Box>
            <Grid container columns={10} spacing={1}>
                <Grid item xs={12}>
                    <Box style={{ height: 400, padding: "10px 10px 0 10px" }}>
                        <MeasureTrendLineChart sourceData={{
                            title: "InBody 評分",
                            xAxis: ["2024-01-03 12:49", "2024-02-01 15:04", "2024-03-06 18:33", "2024-04-05 20:10", "2024-06-01 17:33", "2024-07-01 12:10", "2024-08-02 12:50", "2024-09-01 12:30", "2024-10-03 12:59",
                                "2025-01-03\n12:49", "2025-02-01 15:04", "2025-03-06 18:33", "2025-04-05 20:10", "2025-06-01 17:33", "2025-07-01 12:10", "2025-08-02 12:50", "2025-09-01 12:30", "2025-10-03 12:59"],
                            data: [[67, 69, 70, 73, 72, 74, 77, 79, 78, 67, 69, 70, 73, 72, 74, 77, 79, 78]],
                        }} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box style={{ height: 400, padding: "10px 10px 0 10px" }}>
                        <MeasureTrendLineChart sourceData={{
                            title: "InBody 評分(少)",
                            xAxis: ["2024-01-03 12:49", "2024-02-01 15:04", "2024-03-06 18:33", "2024-04-05 20:10", "2024-06-01 17:33"],
                            data: [[67, 69, 70, 73, 72]],
                        }} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box style={{ height: 400, padding: "10px 10px 0 10px" }}>
                        <MeasurePieBodyCompositionDistributionChart
                            weight={53}    
                            sourceData={{
                            title: "身體組成分佈",
                            xAxis: ["水份", "蛋白質", "礦物質", "體脂肪量"],
                            data: [["32.6", "8.9", "3.0", "10.0"]],
                        }} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box style={{ height: 400, padding: "10px 10px 0 10px" }}>
                        <MeasureTrendAreaChart sourceData={{
                            title: "身體組成分佈",
                            xAxis: ["2024-01-03 12:49", "2024-02-01 15:04", "2024-03-06 18:33", "2024-04-05 20:10", "2024-06-01 17:33", "2024-07-01 12:10", "2024-08-02 12:50", "2024-09-01 12:30", "2024-10-03 12:59",
                                "2025-01-03\n12:49", "2025-02-01 15:04", "2025-03-06 18:33", "2025-04-05 20:10", "2025-06-01 17:33", "2025-07-01 12:10", "2025-08-02 12:50", "2025-09-01 12:30", "2025-10-03 12:59"],
                            yAxis: ["水份", "蛋白質", "礦物質", "體脂肪量"],
                            data: [
                                // 水份
                                ["32.6", "32.8", "33.0", "32.7", "32.9", "33.1", "33.0", "32.8", "32.7", "32.9", "33.2", "33.4", "33.1", "33.3", "33.5", "33.6", "33.4", "33.2"],

                                // 蛋白質
                                ["8.9", "9.0", "9.1", "9.0", "9.2", "9.3", "9.2", "9.1", "9.0", "9.1", "9.2", "9.3", "9.4", "9.3", "9.4", "9.5", "9.4", "9.3"],

                                // 礦物質
                                ["3.0", "3.0", "3.1", "3.0", "3.1", "3.1", "3.2", "3.1", "3.1", "3.2", "3.2", "3.3", "3.2", "3.3", "3.3", "3.4", "3.3", "3.2"],

                                // 體脂肪量
                                ["10.0", "10.3", "10.6", "10.8", "11.0", "11.2", "11.5", "11.8", "12.0", "12.3", "12.5", "12.7", "12.8", "13.0", "13.2", "13.4", "13.5", "13.6"]
                            ],
                        }} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;
